import PropTypes from "prop-types";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import { handleDetailInfoModalOpened } from "@/src/store/listingDetail";

import { tabTitles } from "./tab-titles";

import IconClose from "assets/svg/close.svg";

import Price from "components/common/price";
import Breadcrumb from "components/breadcrumb";
import PriceTrend from "components/price-trend";
import InfoModalScreenTabs from "components/listing-detail/info-modal-screen-tab-wrapper";
import SendMessageButton from "components/common/send-message-button";
import ShowPhone from "components/common/show-phone/ShowPhone";
import Button from "components/common/button";
import ContactFormModal from "components/project-detail/contact-form-modal";

import styles from "./styles.module.css";

const DetailInfoScreen = ({ data, pageType }) => {
  const dispatch = useDispatch();
  const isProject = pageType === "project";
  const isUnitTypes = pageType === "unit-types";
  const mapModalReduxState = useSelector((state) => state.listingDetail.detailInfoModalOpened);
  const selectedModalTabReduxState = useSelector((state) => state.listingDetail.selectedModalTab);

  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [modalFormData, setModalFormData] = useState(null);

  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.wrapperOpened]: mapModalReduxState,
  });

  const titleClasses = classNames({
    [styles.title]: !isProject && !isUnitTypes,
    [styles.projectTitle]: isProject || isUnitTypes,
  });

  const listingInfoClasses = classNames({
    [styles.listingInfo]: !isProject && !isUnitTypes,
    [styles.listingProjectInfo]: isProject || isUnitTypes,
  });

  const {
    id,
    title,
    breadcrumbs,
    priceDetail: { price, currency, trendType, differenceRate, alternativeValue },
    owner: {
      account: { phoneNumber },
    },
    videoUrl,
    virtualTourUrl,
    price: projectPrice,
    salesStatus,
  } = data;

  const videoTab = tabTitles.find((item) => item.key === "video");
  const threeDTab = tabTitles.find((item) => item.key === "three-d");
  !videoUrl && tabTitles.includes(videoTab) && tabTitles.splice(tabTitles.indexOf(videoTab), 1);
  !virtualTourUrl && tabTitles.includes(threeDTab) && tabTitles.splice(tabTitles.indexOf(threeDTab), 1);

  const isConstructionDeal = alternativeValue === "Kat Karşılığı";

  const renderPrice = () => {
    if (isProject) {
      const { priceVisibility, min, max, startPrice } = projectPrice;

      if (priceVisibility === "ASK") return null;

      const isRange = priceVisibility === "RANGE";
      const isStartCount = priceVisibility === "STARTCOUNT";

      const displayPrice = isStartCount ? startPrice : min;
      if (!displayPrice) return null;
      return (
        <div>
          <>
            <Price price={displayPrice} currency={currency} />
            {isRange && max && (
              <>
                &nbsp;-&nbsp;
                <Price price={max} currency={currency} />
              </>
            )}
            {isStartCount && <span className={styles.projectPriceDescription}>&apos;den Başlayan Fiyatlar</span>}
          </>
          {isRange && <p className={styles.projectPriceDescription}>fiyat aralığında gayrimenkuller</p>}
        </div>
      );
    }
    if (isConstructionDeal) {
      return alternativeValue;
    }
    return <Price price={price} currency={currency} />;
  };

  const handleCloseFormModal = () => {
    setIsOpenFormModal(false);
    setModalFormData(null);
  };

  const handleOpenFormModal = () => {
    if (window.location.hash.length > 0) {
      const hashParts = window.location.hash.slice(13).split("-");

      const index = data.flatTypes.findIndex(
        (unitType) => unitType?.area === Number(hashParts[0]) && unitType?.roomCount === hashParts[1]
      );

      setModalFormData(`${data.flatTypes[index]?.roomType}, ${data.flatTypes[index]?.area} m²`);
      setIsOpenFormModal(true);
    } else {
      setIsOpenFormModal(true);
    }
  };

  return (
    <div className={wrapperClasses}>
      <div className={styles.info}>
        <div className={listingInfoClasses}>
          <h1 className={titleClasses}>{title}</h1>
          {!isProject && !isUnitTypes && <Breadcrumb data={breadcrumbs} type="listing-detail-map-screen" />}
        </div>
        <div className={styles.listingActions}>
          <div>{trendType === "down" && <PriceTrend data={differenceRate} />}</div>
          {!isUnitTypes && <div className={styles.priceWrap}>{renderPrice()}</div>}
          <div className={styles.buttonWrap}>
            {isProject || isUnitTypes ? (
              <Button size="M" onClick={() => handleOpenFormModal()} disabled={salesStatus === "FINISHED"}>
                {salesStatus !== "FINISHED" ? "Bilgi Al" : "Satışı Tamamlandı"}
              </Button>
            ) : (
              <>
                <SendMessageButton listingId={id} />
                <ShowPhone listItemInfo={data} phoneNumber={phoneNumber} gtmEventLabel="galeri_detay" />
              </>
            )}
          </div>
          <div
            className={styles.closeWrap}
            onClick={() => {
              dispatch(handleDetailInfoModalOpened());
              if (isUnitTypes) {
                window.history.replaceState(null, "", window.location.origin + window.location.pathname);
              }
            }}
          >
            <IconClose />
          </div>
        </div>
      </div>
      <div className={styles.tabWrap}>
        <InfoModalScreenTabs
          tabTitles={tabTitles}
          listingDetailData={data}
          selectedModalTabReduxState={selectedModalTabReduxState}
          pageType={pageType}
          isUnitTypes={isUnitTypes}
        />
        <div className={styles.tabContent}></div>
      </div>
      {(isUnitTypes || isProject) && (
        <ContactFormModal
          isOpen={isOpenFormModal}
          handleClose={handleCloseFormModal}
          currentCompany={data.formData}
          projectDetailFormData={modalFormData}
          isProjectDetailSticky={!isUnitTypes}
        />
      )}
    </div>
  );
};

DetailInfoScreen.propTypes = {
  data: PropTypes.any,
  pageType: PropTypes.string,
};

export default DetailInfoScreen;
